import { createSlice } from "@reduxjs/toolkit";
import { CreateAppData } from "../types/CreateAppType";
import { deleteLocalBankAction } from "../action/deleteLocalBankAction";

const initialState: CreateAppData = {
  data: null,
  loading: false,
  error: null,
};

const deleteLocalBankSlice = createSlice({
  name: "deleteLocalBankSlice",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(deleteLocalBankAction.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(deleteLocalBankAction.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(deleteLocalBankAction.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const deleteLocalBankReducer = deleteLocalBankSlice.reducer;
